"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-use-before-define
const react_1 = __importDefault(require("react"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const Select_1 = __importDefault(require("@material-ui/core/Select"));
function YearMonthSelectorView(props) {
    const setYear = (e) => {
        props.setYear(e.target.value);
    };
    const setMonth = (e) => {
        props.setMonth(e.target.value);
    };
    const monthItems = [];
    for (let i = 12; i >= 1; i -= 1) {
        monthItems.push(react_1.default.createElement(MenuItem_1.default, { key: i, value: i }, i));
    }
    const yearItems = [];
    for (let year = new Date().getFullYear(); year >= 2018; year -= 1) {
        yearItems.push(react_1.default.createElement(MenuItem_1.default, { key: year, value: year }, year));
    }
    return (react_1.default.createElement("div", { style: {
            display: 'inline-block',
            margin: '10px 0px 20px 10px',
        } },
        react_1.default.createElement(Select_1.default, { style: {
                paddingLeft: '10px',
            }, value: props.year, onChange: setYear }, yearItems),
        "\u5E74",
        react_1.default.createElement(Select_1.default, { style: {
                paddingLeft: '10px',
            }, value: props.month, onChange: setMonth }, monthItems),
        "\u6708"));
}
exports.default = YearMonthSelectorView;
